import React, { useEffect, useState } from 'react';
import {
  PayPalScriptProvider,
  PayPalButtons,
  usePayPalScriptReducer,
  // FUNDING,
} from '@paypal/react-paypal-js';
import css from './CheckoutPage.css';

export default function Paypal(props) {
  const { amount, transactionData , customCurrency } = props;
  // first elem need in arr? - weasel
  const [ButtonRender, setButtonRender] = useState(false);
  console.log('tdata: ' + transactionData);
  const [{ isPending }] = usePayPalScriptReducer();

  const formattedAmount = (amount / 100) * 0.15;
  console.log('Amount: ' + amount);
  console.log('FormattedAmm: ' + formattedAmount);
  console.log('Amount sent: ' + formattedAmount.toFixed(2));

  // const paypal = useRef();
  // function sleep(ms) {
  //   return new Promise(resolve => setTimeout(resolve, ms));
  // }
  const initialOptions = {

    'client-id': 'AfktkzVXzNO63AOmsVBa8kUk9na4TVLiyD-HR-6YQKvSx6U-MC3PVJvhSejhU7BtN9fdFPJGAhaOUsDh',

    //'client-secret':
    //'EAW-ZG5pRRmAblvW242aKlLuBXsPA22T6E424Nud0rSBjFviwylA_Jj7E-xDWoGR2z_PVCe2pJoErP0o', //new
    //'client-id': 'ASY98dv_CoKeCP0kCk99qe6Q0ZPEY7Tk3zbDpCzJY5D6DasDPwM_0QDSEl6wvk2XPwY1AsRrKje-PeTB', //old
    //'client-id': 'sb',

    currency: customCurrency == "Dollar" ?'USD':'EUR',
    intent: 'capture',
  };
  console.log("initialOptions von PayPal.js", initialOptions)
  useEffect(() => {
    setButtonRender(true);
  }, []);

  function createOrder(data, actions, err) {
    console.log('Transaction ' + transactionData.bookingDates.bookingStart.getDate());
    return actions.order
      .create({
        intent: 'CAPTURE',

        purchase_units: [
          {
            description: `Socialbnb Booking: Transaction id:${transactionData.listing.id.uuid}`,

            amount: {
              currency_code: customCurrency == "Dollar" ?'USD':'EUR',
              value: formattedAmount.toFixed(2),
            },
          },
        ],
      })
      .then(order => {
        console.log('The order: ? ' + order);
        return order;
      })
      .catch(err => {
        console.log('creation failed: ' + err);
      });
  }
  function approvedInt(data, actions) {
    actions.order
      .capture()
      .then(e => {
        console.log('Payment sucessful', e);
        props.payPalSucsses(e);
      })
      .catch(err => {
        console.log('approvedInt faield: ' + err);
      });
  }

  return (
    <>
      <PayPalScriptProvider options={initialOptions} deferLoading={false}>
        {isPending ? (
          <div className={css.loaderImage2} />
        ) : (
          <div>
            <PayPalButtons
              createOrder={createOrder}
              onApprove={approvedInt}
              style={{ layout: 'vertical' }}
              fundingSource={'paypal'}
            />
            <PayPalButtons
              createOrder={createOrder}
              onApprove={approvedInt}
              style={{ layout: 'vertical' }}
              fundingSource={'card'}
            />
          </div>

        )}
      </PayPalScriptProvider>
    </>
  );
}
